// src/Heart.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Heart_default = createIcon({
  displayName: "Heart",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M16.2558 3.00429C13.5148 3.11629 11.9998 5.08929 11.9998 5.08929C11.9998 5.08929 10.4848 3.11629 7.74383 3.00429C5.90583 2.92929 4.22083 3.84429 3.11083 5.31129C-0.75117 10.4153 6.56083 16.3863 8.28083 17.9893C9.30983 18.9483 10.5798 20.0873 11.3378 20.7623C11.7168 21.1003 12.2818 21.1003 12.6608 20.7623C13.4188 20.0873 14.6888 18.9483 15.7178 17.9893C17.4378 16.3863 24.7508 10.4153 20.8878 5.31129C19.7788 3.84429 18.0938 2.92929 16.2558 3.00429Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  Heart_default
};
